<template>
    <div class="port-connection" :class="getContainerClassNames" :id="data.pt_id">
        <div v-if="side === 'left' && !!label" class="port-connection-wrapper">
            <div class="port-connection-container">
                <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                        <p
                            v-bind="attrs"
                            v-on="on"
                            class="pl-2 pr-2 pt-1 pb-1 port-fiber-label"
                        >{{ label }}</p>
                    </template>
                    <span :style="{fontSize: '10px'}">{{ label }}</span>
                </v-tooltip>
                <p 
                    v-if="data.connectedFiber" 
                    class="pl-2 pr-2 pt-1 pb-1 fiber-port-container" 
                    :style="{backgroundColor: getTubeColor(data.connectedFiber.fb_nr_tube), color: 'white'}"
                >
                 {{ `T${data.connectedFiber.fb_nr_tube}` }}
                </p>
                <p 
                    v-if="data.connectedFiber" 
                    class="pl-2 pr-2 pt-1 pb-1 fiber-port-container"
                    :style="{backgroundColor: getFiberColor(data.connectedFiber.fb_color), color: 'white'}"
                >
                 {{ `F${data.connectedFiber.fb_nr_in_tube}` }}
                </p>
                <p 
                    v-if="data.connectedPort" 
                    class="pl-2 pr-2 pt-1 pb-1"
                    style="border-left: 1px solid grey;"
                >
                 {{ `PO${data.connectedPort.pt_nr_in_splitter}` }}
                </p>
            </div>
        </div>
        <div v-if="side === 'right'" class="port-circle mr-2"></div>
        <div class="port-label-container pl-3 pr-3 pt-1 pb-1" :class="getClassNames">
            <p>{{ getPortLabel }}</p>
        </div>
        <div v-if="side === 'left'" class="port-circle ml-2"></div>
        <div v-if="side === 'right' && !!label" class="port-connection-wrapper">
            <div class="port-connection-container">
                <p 
                    v-if="data.connectedFiber" 
                    class="pl-2 pr-2 pt-1 pb-1 fiber-port-container"
                    :style="{backgroundColor: getFiberColor(data.connectedFiber.fb_color), color: 'white'}"
                >
                 {{ `F${data.connectedFiber.fb_nr_in_tube}` }}
                </p>
                <p 
                    v-if="data.connectedFiber" 
                    class="pl-2 pr-2 pt-1 pb-1 fiber-port-container" 
                    :style="{backgroundColor: getTubeColor(data.connectedFiber.fb_nr_tube), color: 'white'}"
                >
                 {{ `T${data.connectedFiber.fb_nr_tube}` }}
                </p>
                <p 
                    v-if="data.connectedPort" 
                    class="pl-2 pr-2 pt-1 pb-1"
                    style="border-right: 1px solid grey;"
                >
                 {{ `PO${data.connectedPort.pt_nr_in_splitter}` }}
                </p>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <p
                            v-bind="attrs"
                            v-on="on"
                            class="pl-2 pr-2 pt-1 pb-1 port-fiber-label"
                        >{{ label }}</p>
                    </template>
                    <span :style="{fontSize: '10px'}">{{ label }}</span>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>
  
<script>
  export default {
    name: "Connection",
    props:{
      data: {
        type: Object
      },
      side: {
        type: String
      },
      list: {
        type: Array
      },
      fiberColors: {
        type: Array
      },
      cables:{
        type: Array
      },
      splitters : {
        type: Array
      },
      label: {
        type: String
      }
    },
    computed: {
        getClassNames() {
            return {
                'ml-4': this.side === "left",
                'mr-4': this.side === "right"
            };
        },
        getPortLabel(){
            return this.side === 'left' ? `PI${this.data.pt_nr_in_splitter}` : `PO${this.data.pt_nr_in_splitter}`
        },
        getContainerClassNames() {
            return {
                'port-connection-left': this.side === "right",
                'port-connection-right': this.side === "left"
            };
        },
    },
    methods: {
        getCableLabel(fiber){
            const cable = this.cables.find(item => item.cb_id === fiber.fb_cable_id);
            const label = cable.cb_label ? cable.cb_label :  `Cb: ${cable.cb_id}`;
            return label;
        },
        getTubeColor(nr) {
            let colorNr = nr % 12;
            if (colorNr === 0) {
                colorNr = 12;
            }
            switch (colorNr) {
                case 1:
                    return "#0070C0";
                case 2:
                    return "#FD8408";
                case 3:
                    return "#00B050";
                case 4:
                    return "#974706";
                case 5:
                    return "#A6A6A6";
                case 6:
                    return "#FFFFFF";
                case 7:
                    return "#FF0000";
                case 8:
                    return "#000000";
                case 9:
                    return "#FFFF00";
                case 10:
                    return "#CE1C93";
                case 11:
                    return "#FBA5A3";
                case 12:
                    return "#7AD3F2";
            }
        },
        getFiberColor(colorId){
            let finalColor;
            this.fiberColors.forEach(color => {
                if(color.code === String(colorId)){
                    finalColor = color.libelle;
                }
            })
            return finalColor;
        },
    }
  };
</script>
<style scoped>
.port-connection{
    display: flex;
    align-items: center;
    height: 25px;
}
.port-connection-left{
    justify-content: flex-start;
}
.port-connection-right{
    justify-content: flex-end;
}
.port-connection-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    border: 1px solid rgb(110, 102, 102);
    overflow: hidden;
}
.port-connection-container{
    display: flex;
}
.port-label-container{
    width: 52px;
    background-color: rgb(214, 209, 209);
    border: 1px solid rgb(110, 102, 102);
    border-radius: 5px;
}
.port-connection-container > p, .port-label-container > p{
    text-align: center;
    margin: 0;
}
.fiber-port-container{
    width: 32px;
}
.port-circle{
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: rgb(214, 209, 209);
}
.port-fiber-label{
    width: 62px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/Connection.vue